import { render } from "./PlaceModal.vue?vue&type=template&id=bd5f01fc"
import script from "./PlaceModal.vue?vue&type=script&lang=js"
export * from "./PlaceModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__